/* eslint-disable no-useless-catch */
import { entityService } from './services';

const pathname = '/standard-object-types';

export const StandardObjectTypeApi = {
  find: async () => {
    const url = `${pathname}`;
    try {
      const response = await entityService.get(url);
      return response;
    } catch (error) {
      throw error;
    }
  },
};
